import React from 'react';
import { Modal } from 'antd';
import { useEffect } from 'react';
import { EXCLUSION_EXEMPTION_ITEM } from './checkExemption';
import { useTranslation } from 'react-i18next';

const ExclusionModal = ({ exemptions = [] }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (
      Array.isArray(exemptions) &&
      exemptions.includes(EXCLUSION_EXEMPTION_ITEM)
    ) {
      Modal.error({
        title: t('exclusion_modal.title'),
        content: t('exclusion_modal.body'),
        centered: true
      });
    }
  }, [exemptions]);

  return null;
};

const ExclusionModalMemoized = React.memo(
  ExclusionModal,
  (prevProps, nextProps) => {
    const prevExemptions = prevProps.exemptions || [];
    const nextExemptions = nextProps.exemptions || [];

    if (prevExemptions.length !== nextExemptions.length) {
      return false;
    }

    return prevExemptions.every((prevExemption) =>
      nextExemptions.includes(prevExemption)
    );
  }
);

export { ExclusionModalMemoized as ExclusionModal };
